module.exports = __webpack_public_path__ + "assets/img/customer-bg.d0c7b261.png";